import React, { useState } from 'react';
import { useAlert } from '../ui/alertProvider';
import ApiClient from '../../Services/ApiClient';

const ConfirmVerification: React.FC<{ email: string, onSuccess: (code: string) => void }> = ({ email, onSuccess }) => {
    const [code, setCode] = useState('');
    const { showAlert } = useAlert();
    const [loading, setLoading] = useState(false);

    const handleVerify = async () => {
        if (!code || code.trim().length !== 8) { showAlert('נא הזן קוד בן 8 ספרות', 'error'); return; }
        setLoading(true);
        try {
            // Delegate final validation to server during register; pass code back to parent
            onSuccess(code);
        } catch (err: any) {
            const msg = err?.data || 'קוד לא תקין או שפג';
            showAlert(msg, 'error');
        } finally { setLoading(false); }
    };

    return (
        <div className="page-padding">
            <h3 id="verify-heading">הזן את קוד האימות ששלחנו ל{email}</h3>
            <label htmlFor="verify-code" className="sr-only">קוד אימות</label>
            <input id="verify-code" aria-labelledby="verify-heading" aria-required="true" value={code} onChange={e => setCode(e.target.value.replace(/[^0-9]/g, ''))} maxLength={8} />
            <div className="mt-8">
                <button className="btn btn-primary" onClick={handleVerify} disabled={loading} aria-label="אמת קוד">{loading ? 'בודק...' : 'אמת'}</button>
            </div>
        </div>
    );
};

export default ConfirmVerification;
